export const communityListFilterState = () => ({
  page: 1,
  pageSize: 20,
  searchKey: "",
});
